import { Configuration, AuthenticationResult } from '@azure/msal-browser';
import { SessionStorageToken } from '../../helpers/SessionStorageTokenService';

export const msalConfig: Configuration = {
    auth: {
        clientId: String(process.env.REACT_APP_CLIENT_ID),
        authority: String(process.env.REACT_APP_AUTHORITY),
        redirectUri: String(process.env.REACT_APP_REDIRECT_URI),
        postLogoutRedirectUri: String(process.env.REACT_APP_REDIRECT_URI)
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    }
};

// Scopes OpenID pour obtenir un ID token (le backend valide l'ID token, pas un access token)
export const loginRequestParam = {
    scopes: ["openid", "profile"]
};

export const tokenRequestParam = {
    scopes: ["openid", "profile"]
};

export interface AuthAppResponse {
    isError: boolean;
    errorMsg: string | null;
    response: AuthenticationResult | null;
    token: SessionStorageToken | null;
}
